import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetAllCodingProfileDecoder = () => {
  const [loading, setLoading] = useState(true);
  const [decoderList, setDecoderList] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const getCodingProfileDecoderList = () => {
    setLoading(true);

    axiosClient
      .get('SettingProduct/CoddingProfile/GetAllCoddingDecoder')
      .then(res => {
        if (res.status === 200) {
          setDecoderList(res.data.value ?? []);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return { getCodingProfileDecoderList, loading, decoderList };
};

export default useGetAllCodingProfileDecoder;
